import type { RealtimePostgresChangesPayload } from "@supabase/supabase-js";
import type { AccountBroadcastOperation, AccountBroadcastPayload } from "./AccountBroadcastManager";

export const BROADCAST_COALESCE_MS = 75;

export function shouldIgnoreSelfBroadcast(
  clientOriginToken: string | null,
  clientDeviceToken: string | null,
  payload: { origin_token?: string | null; device_token?: string | null },
): boolean {
  const clientToken = clientDeviceToken ?? clientOriginToken;
  const payloadToken = payload.origin_token ?? payload.device_token ?? null;
  if (!clientToken || !payloadToken) {
    return false;
  }
  return clientToken === payloadToken;
}

/**
 * Converts a compact account broadcast into the minimal postgres_changes shape
 * that Query.subscribe and subscribeList already understand.
 */
export function broadcastPayloadToPostgresChange(
  payload: AccountBroadcastPayload,
  event: AccountBroadcastOperation = payload.operation,
): RealtimePostgresChangesPayload<{ id: string; is_deleted?: boolean }> {
  const tableName = payload.table_name;
  const commitTimestamp = new Date().toISOString();

  if (event === "DELETE") {
    return {
      eventType: "DELETE",
      new: {},
      old: { id: payload.row_id },
      schema: "public",
      table: tableName,
      commit_timestamp: commitTimestamp,
      errors: [],
    };
  }

  const newRecord: { id: string; is_deleted?: boolean } = { id: payload.row_id };
  if (payload.is_deleted) {
    newRecord.is_deleted = true;
  }

  return {
    eventType: event === "INSERT" ? "INSERT" : "UPDATE",
    new: newRecord,
    old: event === "UPDATE" ? { id: payload.row_id } : {},
    schema: "public",
    table: tableName,
    commit_timestamp: commitTimestamp,
    errors: [],
  };
}
